import { useLazyQuery, useMutation } from "@apollo/client/react";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useRef, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import DocumentViewer from '../../../components/DocumentViewer';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_EVALUACION_PRECIO } from '../../../data/graphQL/queries/GestionPrecio/getEvaluacionPrecio';
import { GET_PLAN_CUIDADO_LISTA_PRECIO } from '../../../data/graphQL/queries/GestionPrecio/getPlanCuidadoListaPrecio';
import { GET_PRECIO_AUTORIZADORES } from '../../../data/graphQL/queries/GestionPrecio/getPrecioAutorizadores';
import { GET_ARCHIVO_COTIZACION } from '../../../data/graphQL/queries/GestionPrecio/getArchivoCotizacion';
import { GET_AUTORIZACION_CONTROL } from '../../../data/graphQL/queries/GestionPrecio/getAutorizacionControl';
import './gestionPrecioContent.scss';
import { FileInput } from '../../../components/fileInput/FileInput';
import { obtenerDataBytesImagen } from '../../../actions/ImagenActionBytes';
import { DELETE_DOCUMENTO_COTIZACION } from '../../../data/graphQL/mutations/GestionPrecio/deleteFileCotizacion';
import { ADD_DOCUMENTO_COTIZACION } from '../../../data/graphQL/mutations/GestionPrecio/uploadFileCotizacion';
import { useLocation } from 'react-router-dom';
import { SAVE_AUTORIZACION_PRECIO } from '../../../data/graphQL/mutations/GestionPrecio/saveAutorizacionPrecio';

const locale = "es-ES";

export const GestionPrecioContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const [allowedWrite, setAllowedWrite] = useState(false);
  const [archivoCotizacion, setArchivoCotizacion] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  const [evaluacion, setEvaluacion] = useState(null);
  const [listaPrecio, setListaPrecio] = useState(null);
  const [autorizadores, setAutorizadores] = useState([]);

  const txtContrato = useRef(null);

  const [disabledGuardar, setDisabledGuardar] = useState(false);

  const rutasStorage = localStorage.getItem('navigationRoutes');
  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;
      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  const initialSaveData = {
    idEvaluacion: 0,
    precioControl: '',
    precioNuevo: '',
    idAutorizador: ''
  };

  const [dataSave, setDataSave] = useState(initialSaveData);

  const [saveAutorizacion, { error: saveAutorizacionError, loading: saveAutorizacionLoading }] = useMutation(SAVE_AUTORIZACION_PRECIO, {
    onCompleted: (data) => {
      if (data.saveAutorizacionPrecio) {
        toast.success("El contrato se grabo correctamente.");
        txtContrato.current.value = "";
        cleanScreen();
        txtContrato.current.focus();
      } else {
        toast.error("Se produjo un error al intentar procesar la solicitud");
      }
    }
  });

  useEffect(() => {
    setChildrenAction(() => <>

            {allowedWrite &&
      <CustomButton
        onClick={handleSave}
        isLoading={saveAutorizacionLoading}
        disabled={disabledGuardar}>
        
                    Guardar
                </CustomButton>}
        </>
    );
  }, [setChildrenAction, allowedWrite, dataSave, archivoCotizacion, disabledGuardar, saveAutorizacionLoading]);

  useEffect(() => {
    txtContrato.current.value = "";
    cleanScreen();

    if (!autorizadoresLoading) {
      getAutorizadores();
    }
  }, []);

  useEffect(() => {
    if (!!evaluacion && evaluacion?.idPlanCuidado > 0)
    getPlanCuidadoListaPrecio({variables: { idPlanCuidado: evaluacion?.idPlanCuidado, idCliente: evaluacion?.idCliente }});
  }, [evaluacion]);

  const [getAutorizadores, { data: autorizadoresData, loading: autorizadoresLoading }] = useLazyQuery(GET_PRECIO_AUTORIZADORES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!autorizadoresData) return;
    setAutorizadores(autorizadoresData.gestionPrecioAutorizadores);
  }, [autorizadoresData]);

  const cleanScreen = () => {
    setEvaluacion(null);
    setListaPrecio(null);
    setArchivoCotizacion(null);
    setDataSave(initialSaveData);
  };

  const [getEvaluacionPrecio, { data: evaluacionPrecioData, loading: evaluacionLoading }] = useLazyQuery(GET_EVALUACION_PRECIO, {
    fetchPolicy: 'no-cache',
    variables: { idEvaluacion: txtContrato.current != null ? parseInt(txtContrato.current.value, 10) : 0 }
  });

  useEffect(() => {
    if (!evaluacionPrecioData) return;
    setEvaluacion(evaluacionPrecioData.evaluacionPrecio);
    if (evaluacionPrecioData.evaluacionPrecio != null) {
      setDataSave((previousData) => ({
        ...previousData,
        idEvaluacion: evaluacionPrecioData.evaluacionPrecio.idEvaluacion
      }));
      getArchivoCotizacion({variables: { idEvaluacion: txtContrato.current != null ? parseInt(txtContrato.current.value, 10) : 0 }});
    } else {
      cleanScreen();
      toast.error("El contrato debe estar cotizado, tener un plan asignado y el resultado del presupuesto no estar rechazado.");
    }
  }, [evaluacionPrecioData]);

  const [getPlanCuidadoListaPrecio, { data: planCuidadoData }] = useLazyQuery(GET_PLAN_CUIDADO_LISTA_PRECIO, {
    fetchPolicy: 'no-cache'    
  });

  useEffect(() => {
    if (!planCuidadoData) return;
    setListaPrecio(planCuidadoData.planCuidadoListaPrecioTango);
    setDataSave((previousData) => ({
      ...previousData,
      precioControl: planCuidadoData.planCuidadoListaPrecioTango.precioControl
    }));
  }, [planCuidadoData]);


  const [getArchivoCotizacion, { data: archivoData }] = useLazyQuery(GET_ARCHIVO_COTIZACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!archivoData) return;
    setArchivoCotizacion(archivoData.evaluacionArchivoCotizacion);
  }, [archivoData]);

  const [getAutorizacionControl, { data: dataAutorizacionControl }] = useLazyQuery(GET_AUTORIZACION_CONTROL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAutorizacionControl) return;
    if (dataAutorizacionControl.autorizacionControl != null && dataAutorizacionControl?.autorizacionControl?.filter((x) => x.idEstado == 1)?.length > 0) {
      toast.error("El contrato ya tiene generada una solicitud.");
      setDisabledGuardar(true);
    } else {
      setDisabledGuardar(false);
    }
  }, [dataAutorizacionControl]);

  const handleKeyFilter = (e) => {
    if (e.keyCode == 13) {
      handleTextFilter();
    }
  };

  const handleTextFilter = () => {
    if (txtContrato.current.value != "") {
      cleanScreen();
      getAutorizacionControl({ variables: { idEvaluacion: parseInt(txtContrato.current.value, 10), idEvento: 2 } });
      getEvaluacionPrecio({ variables: { idEvaluacion: parseInt(txtContrato.current.value, 10) } });
    } else {
      cleanScreen();
    }
  };

  const handleTextClean = () => {
    txtContrato.current.value = "";
    cleanScreen();
    txtContrato.current.focus();
  };

  const handleSearch = () => {
    if (!evaluacionLoading) {
      getEvaluacionPrecio();
    }
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    if (name != 'precioNuevo' || name == 'precioNuevo' && regExpDecimal.test(value)) {
      setDataSave((previousData) => ({
        ...previousData,
        [name]: value
      }));
    }
  };

  const regExpDecimal = /^[-+]?\d*\.?\d*$/;
  const camposValidados = () => {
    // contrato
    if (txtContrato.current == null || txtContrato.current.value == '' || parseInt(txtContrato.current.value, 10) <= 0) {
      toast.error("Debe ingresar el contrato.");
      return false;
    }

    // Precio
    if (dataSave.precioNuevo == '') {
      toast.error("Debe ingresar el precio cambiar.");
      return false;
    }

    if (isNaN(parseFloat(dataSave.precioNuevo))) {
      toast.error("El precio a cambiar debe ser numérico.");
      return false;
    }

    if (!regExpDecimal.test(dataSave.precioNuevo)) {
      toast.error("El formato del precio a cambiar no es válido.");
      return false;
    }

    if (parseFloat(dataSave.precioNuevo) <= 0) {
      toast.error("El precio a cambiar debe ser mayor a 0.");
      return false;
    }

    // Autorizador
    if (dataSave.idAutorizador == '' || parseInt(dataSave.idAutorizador, 10) <= 0) {
      toast.error("Debe seleccionar el autorizador.");
      return false;
    }

    // Archivo
    if (archivoCotizacion == null || archivoCotizacion.archivo.length <= 0) {
      toast.error("Debe ingresar el archivo con la cotización.");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (camposValidados()) {
      saveAutorizacion({
        variables: {
          idEvaluacion: dataSave.idEvaluacion,
          idAutorizador: dataSave.idAutorizador,
          precioControl: dataSave.precioControl,
          precioNuevo: parseFloat(dataSave.precioNuevo)
        }
      });
    }
  };

  // UPLOAD FILE

  const generarImagen = (name, rawImageData) => {
    obtenerDataBytesImagen(rawImageData).then((convertedImage) => {
      setArchivoCotizacion(convertedImage);
      const parametros = {
        idEvaluacion: txtContrato.current != null ? parseInt(txtContrato.current.value, 10) : 0,
        contentType: convertedImage.contenttype,
        titulo: convertedImage.titulo,
        archivo: convertedImage.archivo,
        extension: convertedImage.extension
      };
      saveFileCotizacion({ variables: parametros });
    });
  };

  const handlePreview = () => {
    if (archivoCotizacion != null) {
      setOpenPreview(true);
    }
  };

  const [saveFileCotizacion, { errorFile, datosFile }] = useMutation(ADD_DOCUMENTO_COTIZACION, {
    onCompleted: (datosFile) => {
    },
    onError: (errorFile) => {
      return false;
    }
  });

  const [deleteFileCotizacion, { errorDes, datosDes }] = useMutation(DELETE_DOCUMENTO_COTIZACION, {
    variables: { idEvaluacion: dataSave?.idEvaluacion },
    onCompleted: (datosDes) => {
      setArchivoCotizacion(null);
    },
    onError: (datosDes) => {
      return false;
    }
  });

  const handleDeleteFile = () => {
    deleteFileCotizacion();
  };

  return (
    <div className='card-container' style={{ marginTop: "-5px" }}>
            <Grid
        container
        spacing={2}>
        
                <Grid size={{ md: 12 }}>
                    <TextField
            label="Contrato"
            name="txtContrato"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtContrato}
            onKeyUp={(e) => handleKeyFilter(e)}
            sx={{ backgroundColor: 'white' }}
            InputProps={{
              endAdornment:
              <InputAdornment position="end">
                                    <SearchIcon
                  onClick={handleTextFilter}
                  sx={{ cursor: 'pointer' }} />
                
                                    <ClearIcon
                  onClick={handleTextClean}
                  sx={{ cursor: 'pointer' }} />
                
                                </InputAdornment>

            }} />
          
                </Grid>
                <Grid size={{ md: 4 }}>
                    <strong>Paciente</strong>
                    <br />
                    <div className='label'>{evaluacion != null ? evaluacion?.apellido + " " + evaluacion?.nombre : "-"}</div>
                </Grid>
                <Grid size={{ md: 5 }}>
                    <strong>Delegación</strong>
                    <br />
                    <div className='label'>{evaluacion != null ? evaluacion?.delegacion : "-"}</div>
                </Grid>
                <Grid size={{ md: 3 }}>
                    <strong>Plan de Cuidado</strong>
                    <br />
                    <div className='label'>{evaluacion != null ? evaluacion?.planCuidado : "-"}</div>
                </Grid>
                <Grid size={{ md: 4 }}>
                    <strong>Período</strong>
                    <br />
                    <div className='label'>{evaluacion != null ? moment(evaluacion?.fechaDesde).format("DD/MM/YYYY") + " - " + moment(evaluacion?.fechaHasta).format("DD/MM/YYYY") : "-"}</div>
                </Grid>
                <Grid size={{ md: 5 }}>
                    <strong>Precio diario</strong>
                    <br />
                    <div className='label'>{evaluacion != null ? "$ " + evaluacion?.precioDiario : "-"}</div>
                </Grid>
                <Grid size={{ md: 3 }}>
                    <strong>Tipo de precio</strong>
                    <br />
                    <div className='label'>{listaPrecio != null ? listaPrecio?.tipoPrecio : "-"}</div>
                </Grid>
                <Grid size={{ md: 4 }}>
                    <strong>Precio SAP</strong>
                    <br />
                    <div className='label'>{listaPrecio != null ? "$ " + listaPrecio?.precio : "-"}</div>
                </Grid>
                <Grid size={{ md: 5 }}>
                    <strong>Precio control</strong>
                    <br />
                    <div className='label'>{listaPrecio != null ? "$ " + listaPrecio?.precioControl : "-"}</div>
                </Grid>
                <Grid size={{ md: 3 }}>
                    <strong>Vigencia</strong>
                    <br />
                    <div className='label'>{listaPrecio != null ? listaPrecio?.vigencia : "-"}</div>
                </Grid>
                <Grid size={{ md: 3 }}>
                    <TextField
            label="Precio a cambiar"
            name="precioNuevo"
            size="small"
            type="text"
            variant="outlined"
            value={dataSave?.precioNuevo}
            onChange={handleChange}
            sx={{ backgroundColor: 'white' }}
            disabled={dataSave.idEvaluacion <= 0} />
          
                </Grid>
                <Grid size={{ md: 5 }}>
                    <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                        <InputLabel id="select-delegacion">Autorizador</InputLabel>
                        <Select
              labelId="select-autorizador"
              options={autorizadores}
              label='Autorizador'
              onChange={handleChange}
              value={dataSave?.idAutorizador}
              name='idAutorizador'
              disabled={dataSave.idEvaluacion <= 0}>
              
                            {autorizadores && autorizadores.map((autorizador) => {
                return <MenuItem value={autorizador.idUsuario}> {autorizador.apellido} {autorizador.nombre} </MenuItem>;
              })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ md: 4 }}>
                    {
          evaluacion?.idEvaluacion != '' && evaluacion?.idEvaluacion > 0 &&
          <FileInput
            label='Subir cotización'
            name="documentoAdjunto"
            loadedFileName={archivoCotizacion?.titulo ?? ''}
            validExtensions={['PDF']}
            maxFileSize={3}
            onDeleteImage={handleDeleteFile}
            onChange={(rawImageData) => generarImagen("documentoAdjunto", rawImageData)}
            mobileLayout={false}
            onClickImagen={handlePreview} />

          }
                </Grid>
            </Grid>

            {openPreview && <DocumentViewer data={archivoCotizacion} setOpenDlg={setOpenPreview} download={true} />}
        </div>);

};